import React, { useState } from 'react';
import { X } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface EditPlotModalProps {
  isOpen: boolean;
  onClose: () => void;
  plot: {
    plotNumber: string;
    size: string;
    facing: string;
    price: string;
    status: string;
    project: string;
  };
}
export function EditPlotModal({
  isOpen,
  onClose,
  plot
}: EditPlotModalProps) {
  const [plotData, setPlotData] = useState({
    plotNumber: plot.plotNumber,
    size: plot.size,
    facing: plot.facing,
    price: plot.price,
    status: plot.status
  });
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!plotData.plotNumber || !plotData.size || !plotData.price) {
      alert('Please fill all required fields');
      return;
    }
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
    }, 2000);
  };
  return <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-562">
        <div className="bg-white border border-gray-300 max-w-lg w-full shadow-lg" data-id="element-563">
          <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-564">
            <h3 className="font-bold text-lg" data-id="element-565">Edit Plot {plot.plotNumber}</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-566">
              <X className="w-5 h-5" data-id="element-567" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-568">
            <div className="p-3 bg-gray-50 border border-gray-200" data-id="element-569">
              <p className="text-sm text-gray-600" data-id="element-570">Project:</p>
              <p className="font-bold" data-id="element-571">{plot.project}</p>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-572">
              <div data-id="element-573">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-574">
                  Plot Number *
                </label>
                <input type="text" required value={plotData.plotNumber} onChange={e => setPlotData({
                ...plotData,
                plotNumber: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-575" />
              </div>

              <div data-id="element-576">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-577">
                  Size (Sq. Ft) *
                </label>
                <input type="text" required value={plotData.size} onChange={e => setPlotData({
                ...plotData,
                size: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-578" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-579">
              <div data-id="element-580">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-581">
                  Facing
                </label>
                <select value={plotData.facing} onChange={e => setPlotData({
                ...plotData,
                facing: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-582">
                  <option value="" data-id="element-583">Select</option>
                  <option value="North" data-id="element-584">North</option>
                  <option value="South" data-id="element-585">South</option>
                  <option value="East" data-id="element-586">East</option>
                  <option value="West" data-id="element-587">West</option>
                  <option value="North-East" data-id="element-588">North-East</option>
                  <option value="North-West" data-id="element-589">North-West</option>
                  <option value="South-East" data-id="element-590">South-East</option>
                  <option value="South-West" data-id="element-591">South-West</option>
                </select>
              </div>

              <div data-id="element-592">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-593">
                  Price (Lakhs) *
                </label>
                <input type="text" required value={plotData.price} onChange={e => setPlotData({
                ...plotData,
                price: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-594" />
              </div>
            </div>

            <div data-id="element-595">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-596">
                Status
              </label>
              <select value={plotData.status} onChange={e => setPlotData({
              ...plotData,
              status: e.target.value
            })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-597">
                <option value="Available" data-id="element-598">Available</option>
                <option value="Booked" data-id="element-599">Booked</option>
                <option value="Sold" data-id="element-600">Sold</option>
              </select>
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-601">
              <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-602">
                Cancel
              </button>
              <button type="submit" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-603">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Plot Updated" message={`Plot ${plotData.plotNumber} has been updated successfully.`} type="success" data-id="element-604" />
    </>;
}